module.exports = __webpack_public_path__ + "media/Video 8.5d72a7cd.mp4";